import React from 'react';
import { InventoryLayout } from '../components/inventory/InventoryLayout';
export function PrivacyPolicyPage() {
  return <InventoryLayout data-id="element-629">
      {/* Page Header */}
      <div className="bg-navy-900 py-12 sm:py-16 border-b border-white/10" data-id="element-630">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-631">
          <div className="border-l-4 border-cg-orange-600 pl-6" data-id="element-632">
            <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-633">
              Privacy Policy
            </h1>
          </div>
        </div>
      </div>

      <section className="bg-white py-16 sm:py-24" data-id="element-634">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-635">
          <p data-id="element-636">Last updated: February 2025</p>
          <p data-id="element-637">
            Chiltern Global Ltd ("we", "us", or "our") is committed to
            protecting and respecting your privacy. This policy sets out the
            basis on which any personal data we collect from you, or that you
            provide to us, will be processed by us.
          </p>
          <h3 data-id="element-638">Information We Collect</h3>
          <p data-id="element-639">We may collect and process the following data about you:</p>
          <ul data-id="element-640">
            <li data-id="element-641">
              Information you give us by filling in forms on our site (e.g.
              contact forms, order requests).
            </li>
            <li data-id="element-642">
              If you contact us, we may keep a record of that correspondence.
            </li>
            <li data-id="element-643">
              Details of your visits to our site and the resources that you
              access.
            </li>
          </ul>
          <h3 data-id="element-644">How We Use Your Information</h3>
          <p data-id="element-645">We use information held about you in the following ways:</p>
          <ul data-id="element-646">
            <li data-id="element-647">
              To ensure that content from our site is presented in the most
              effective manner for you and for your computer.
            </li>
            <li data-id="element-648">
              To provide you with information, products or services that you
              request from us.
            </li>
            <li data-id="element-649">
              To carry out our obligations arising from any contracts entered
              into between you and us.
            </li>
          </ul>
          <h3 data-id="element-650">Data Security</h3>
          <p data-id="element-651">
            We take appropriate measures to ensure that your data is treated
            securely and in accordance with this privacy policy. Unfortunately,
            the transmission of information via the internet is not completely
            secure. Although we will do our best to protect your personal data,
            we cannot guarantee the security of your data transmitted to our
            site.
          </p>
          <h3 data-id="element-652">Contact</h3>
          <p data-id="element-653">
            Questions, comments and requests regarding this privacy policy are
            welcomed and should be addressed to orders@chilternglobal.com.
          </p>
        </div>
      </section>
    </InventoryLayout>;
}